var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-plyr',{ref:"plyr",attrs:{"options":_vm.options}},[_c('video',{attrs:{"controls":"","crossorigin":"","playsinline":""}},[_c('source',{attrs:{"size":"720","src":_vm.getVideoLink(this.videoContent.fileName),"type":"video/mp4"}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }